(function () {
    'use strict';

    a3_cabin_reports.factory('httpHeaderInterceptor', httpHeaderInterceptor);

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name httpHeaderInterceptor
    * @description 
    *  Add CrewToken on non login requests
    * @ngInject
    */
    function httpHeaderInterceptor($location, localStorageMD5Service) {
        return {
            request: function (config) {
                if ($location.$$url != "/login") {
                    if (config.url.includes("api")) {
                        var user = localStorageMD5Service.get('user');
                        var aimsIdToString = user.aimsId.toString();
                        if (config.method === "POST" || config.method === "PUT") {
                            var dataToHash = typeof config.data === "object" ? angular.toJson(config.data) + aimsIdToString : config.data + aimsIdToString;
                            var hash = (dataToHash).getHash();
                            config.headers['X-VCode'] = hash;
                        }
                        else if (config.method === "GET") {
                            var absolutePath = config.url;
                            var stringToHash = absolutePath.substring(absolutePath.lastIndexOf("/") + 1, absolutePath.length);
                            var hash = (stringToHash + aimsIdToString).getHash();
                            config.headers['X-VCode'] = hash;
                        }
                    }

                }
                return config;
            }
        };
    }

})();